/** Public launch gate — baked at build via VITE_PUBLIC_LAUNCH_MODE. */
export type LaunchMode = "prelaunch" | "live";

export function getLaunchMode(): LaunchMode {
  const raw = (import.meta.env.VITE_PUBLIC_LAUNCH_MODE ?? "prelaunch").trim().toLowerCase();
  if (raw === "live") return "live";
  if (raw !== "prelaunch" && import.meta.env.DEV) {
    console.warn(
      `[launchMode] Invalid VITE_PUBLIC_LAUNCH_MODE="${raw}" — falling back to prelaunch`,
    );
  }
  return "prelaunch";
}

export function isPrelaunch(): boolean {
  return getLaunchMode() === "prelaunch";
}

export function isLiveLaunch(): boolean {
  return getLaunchMode() === "live";
}

/** Paths that do not require a consumer session (marketing / auth entry / live teaser). */
export function isPublicMarketingPath(pathname: string): boolean {
  if (pathname === "/" || pathname === "") return true;
  if (pathname === "/about") return true;
  if (pathname === "/user/login" || pathname.startsWith("/user/login/")) return true;
  if (pathname === "/reset-password") return true;
  if (pathname.startsWith("/vendor") || pathname === "/for-venues") return true;
  if (pathname.startsWith("/pulse-ops-x7k2")) return true;
  if (pathname.startsWith("/dev/")) return true;
  return false;
}
